module.exports = __webpack_public_path__ + "static/media/icon-dropdown-white.616c3a35.svg";